import React from "react";
import { FileIcon } from "react-file-icon";
import { Box, IconButton, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { makeKey } from "../../../../../utils/helpers";
import { FileDownload } from "../../../file-download/components/file-download/file-download-component";
import { FileAttachment } from "../../../types/file-attachment.interface";
import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import {
  getFileNameFromFileAttachment,
  getFileExtensionFromFileAttachment,
} from "../../../types/file-attachment.functions";
import { FileUploadAttachedFilesProps } from "./file-upload-attached-files.props";
import { FileItem, FileList, StyledBox } from "./file-upload-attached-files.styles";

export const FileUploadAttachedFiles = withShowIf((props: FileUploadAttachedFilesProps) => {
  const removeAttachment = (item: FileAttachment) => () => props.removeAttachment(item.id);

  return (
    <FileList>
      {props.attachedFiles.map((item: FileAttachment) => (
        <StyledBox key={makeKey(item.attachment, item.id)}>
          <FileDownload
            disabled={!props.canDownload}
            saveAsFileName={getFileNameFromFileAttachment(item)}
            url={item.attachment}
            variant="text"
          >
            <FileItem title={getFileNameFromFileAttachment(item)}>
              <FileIcon extension={getFileExtensionFromFileAttachment(item)} />
              <Typography variant="h4" noWrap>
                {getFileNameFromFileAttachment(item)}
              </Typography>
            </FileItem>
          </FileDownload>
          <Box>
            <IconButton disabled={!props.canDelete} onClick={removeAttachment(item)} title="Delete">
              <CloseIcon />
            </IconButton>
          </Box>
        </StyledBox>
      ))}
    </FileList>
  );
});
